var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 48,
    viewBox: "0 0 71 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.89 0.119995H6.60999C3.09746 0.119995 0.24999 2.96746 0.24999 6.48V24.12H70.25V6.48C70.25 2.96746 67.4025 0.119995 63.89 0.119995Z",
    fill: "#0038A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.24999 40.75C0.24999 44.2625 3.09746 47.11 6.60999 47.11H63.88C65.5668 47.11 67.1845 46.4399 68.3772 45.2472C69.5699 44.0545 70.24 42.4368 70.24 40.75V24.12H0.23999L0.24999 40.75Z",
    fill: "#CE1126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14999 1.94998C0.931154 3.14573 0.246144 4.78254 0.249989 6.48998V40.76C0.251138 42.4852 0.955284 44.1354 2.19999 45.33L25.25 24.12L2.14999 1.94998Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 27.62C12.4591 27.62 14.25 25.8291 14.25 23.62C14.25 21.4109 12.4591 19.62 10.25 19.62C8.04085 19.62 6.24999 21.4109 6.24999 23.62C6.24999 25.8291 8.04085 27.62 10.25 27.62Z",
    fill: "#F6D660"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhl);
export default __webpack_public_path__ + "static/media/PHL.4d221d39fe5ea9cefc88439de5385413.svg";
export { ForwardRef as ReactComponent };